<!--
/*******************************************************************************
*@ 컴포넌트명   : PushGuidePopup.vue
*@ 컴포넌트설명 : Push가이드팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <popup
      :opened.sync="isGuidePopupOpen"
      :useHeader="false"
      :useFooter="true"
      class="layerGuide solid"
    >
      <template #content>
        <div class="setting">
          <button class="btn icon md normal left">
            <!-- 1주일 -->
            {{$t("MMAIN-04-01-02-01")}}
            <i class="icon icon-dropdown-arrow" />
          </button>
          <button class="btn icon md normal right">
            <i class="icon icon-setting" />
            <!-- 알림설정 -->
            {{$t("MMAIN-04-01-02-02")}}
          </button>

          <div class="guide left">
            <!-- 알림 메시지 조회<br/>기간을 설정할 수<br/>있습니다. -->
            {{$t("MMAIN-04-01-02-03")}}
          </div>
          <div class="guide right">
            <!-- 알림 수신 여부와<br/>항목을 설정하세요. -->
            {{$t("MMAIN-04-01-02-04")}}
          </div>
        </div>
      </template>
      <template #footer>
        <button class="btn md solid" @click="() => {isGuidePopupOpen = false}">
          <!--닫기-->
          {{$t("MMAIN-04-01-02-05")}}
        </button>
      </template>
    </popup>
    <!-- action sheet 들어 가는 곳 -->
  </article>
</template>

<script>
export default {
  props: ["opened"],
  mounted() {},
  created() {},
  data() {
    return {};
  },
  computed: {
    isGuidePopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    setAcnoAll() {},
  },
};
</script>
